export function getLanguage() {
    const lang = localStorage.getItem('language');
    if (lang === 'es') {
      localStorage.setItem('language', 'en');
      return 'en';
    }
    return lang;
  }
  
  export function setLanguage(lang) {
    localStorage.setItem('language', lang);
  }
  